import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { axios } from '~/utils/axios';

const OmniApplicationContext = React.createContext({});

export function OmniApplicationContextProvider({ value, children }) {
  if (axios.defaults.baseURL !== value.apiBaseURL) {
    axios.defaults.baseURL = value.apiBaseURL;
  }

  return (
    <OmniApplicationContext.Provider
      value={{
        apiBaseURL:
          process.env.REACT_APP_API_URL || process.env.REACT_APP_DOMAIN,
        chatbotBaseURL: process.env.REACT_APP_CHATBOT_URL,
        ...value,
      }}
    >
      {children}
    </OmniApplicationContext.Provider>
  );
}

OmniApplicationContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({
    apiBaseURL: PropTypes.string,
    chatbotBaseURL: PropTypes.string,

    initialRoutePath: PropTypes.string,
    isStandalone: PropTypes.bool,

    onNotificationsEnabledChange: PropTypes.func,
    onSynchronizePermissions: PropTypes.func,
  }).isRequired,
};

/**
 * @returns {Partial<{
 *   isStandalone?: boolean;
 *
 *   apiBaseURL: string;
 *   chatbotBaseURL: string;
 *   initialRoutePath: string;
 *
 *   mwApiKey: string;
 *   mwAdminEmail: string | null;
 *   mwUserEmail: string | null;
 *
 *   onNotificationsEnabledChange: (params: { checked: boolean, userId: string }) => void;
 *   onSynchronizePermissions: (params: { userId: string }) => void;
 * }>}
 */
export function useAppContext() {
  return React.useContext(OmniApplicationContext) || {};
}

export function OmniApplicationInitialLocationWatcher() {
  const appContext = useAppContext();
  const history = useHistory();

  React.useEffect(() => {
    if (appContext.initialRoutePath) {
      history.push(appContext.initialRoutePath);
    }
  }, [appContext.initialRoutePath, history]);

  return null;
}
